import LegalPage from './LegalPage'

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy">
      <p className="mt-4 text-sm text-slate-700">
        InnovateFlow is built so that your documents stay private: your work is matched on a signature of the idea, not
        the idea itself, and your data is stored in Australia (ap-southeast-2).
      </p>
    </LegalPage>
  )
}
